// extracted by mini-css-extract-plugin
export default {"colored_title":"faqs_colored_title__wSzNn"};